import { InjectionToken } from "@angular/core";

import { SCENE7_MAX_HEIGHT, SCENE7_MAX_WIDTH } from "./scene7.constants";

export type Scene7BasePath = `${string}://${string}`;

/**
 * Global settings for Scene7 images
 */
export interface Scene7ImageSettings {
    /**
     * Scene7 endpoint, including host and base path
     */
    baseURL: Scene7BasePath;

    /**
     * Default src of the fallback images
     */
    defaultFallbackImageSrc: Record<number, string> & { default: string };

    /**
     * Absolute max width that cannot be outpassed when generating images
     */
    maxWidth: number;
    /**
     * Absolute max height that cannot be outpassed when generating images
     */
    maxHeight: number;
}

/**
 * Default value of Scene7 settings
 */
export const DEFAULT_SCENE7_IMAGE_SETTINGS: Scene7ImageSettings = {
    baseURL: "https://assets.hermes.com/is/image/hermesproduct",
    defaultFallbackImageSrc: {
        default: "default_image_src",
        [3 / 4]: "default_image_src_f34",
        [4 / 3]: "default_image_src_f43.png",
        [16 / 9]: "default_image_src_f169.png",
    },
    maxWidth: SCENE7_MAX_WIDTH,
    maxHeight: SCENE7_MAX_HEIGHT,
};

/**
 * Injection token for {@link Scene7ImageSettings}
 */
export const SCENE7_IMAGE_SETTINGS = new InjectionToken<Scene7ImageSettings>(
    "SCENE7_IMAGE_SETTINGS",
    {
        factory: () => DEFAULT_SCENE7_IMAGE_SETTINGS,
    },
);
